export const getMaskedCardNumber = (cardNumber: string): string => {
  const trimmedNumber = cardNumber.replace(/[X\*]/g, '');
  const endOfNumber = trimmedNumber.slice(trimmedNumber.length - 4);
  return `•••• ${endOfNumber}`;
};
